module.exports = __webpack_public_path__ + "static/media/main2.38a55767.svg";